import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// Create axios instance with base URL
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to add auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Authentication API
export const authAPI = {
  login: async (email: string, password: string) => {
    const response = await apiClient.post('/auth/login', { email, password });
    return response.data;
  },
  register: async (name: string, email: string, password: string, role: string) => {
    const response = await apiClient.post('/auth/register', { name, email, password, role });
    return response.data;
  },
  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },  
  getProfile: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
  getAllUsers: async () => {
    const response = await apiClient.get('/auth/users');
    return response.data;
  },
  updateUser: async (userId: string, userData: { name?: string; email?: string; role?: string }) => {
    const response = await apiClient.put(`/auth/users/${userId}`, userData);
    return response.data;
  },
  deleteUser: async (userId: string) => {
    const response = await apiClient.delete(`/auth/users/${userId}`);
    return response.data;
  }
};

export const publisherAPI = {
  getPublishers: async () => {
    const response = await apiClient.get('/publishers');
    return response.data;
  },
  createPublisher: async (data: any) => {
    const response = await apiClient.post('/publishers', data);
    return response.data;
  },
  updatePublisher: async (id: string, data: any) => {
    const response = await apiClient.put(`/publishers/${id}`, data);
    return response.data;
  },
  deletePublisher: async (id: string) => {
    const response = await apiClient.delete(`/publishers/${id}`);
    return response.data;
  },
};

export const bookReleaseAPI = {
  getBookReleases: async (params?: any) => {
    const response = await apiClient.get('/book-releases', { params });
    return response.data;
  },
  getFeaturedReleases: async () => {
    const response = await apiClient.get('/book-releases/featured');
    return response.data;
  },
  createBookRelease: async (data: any) => {
    const response = await apiClient.post('/book-releases', data);
    return response.data;
  },
  updateBookRelease: async (id: string, data: any) => {
    const response = await apiClient.put(`/book-releases/${id}`, data);
    return response.data;
  },
  deleteBookRelease: async (id: string) => {
    const response = await apiClient.delete(`/book-releases/${id}`);
    return response.data;
  },
  getBookRelease: async (id: string) => {
    const response = await apiClient.get(`/book-releases/${id}`);
    return response.data;
  },
};

export const blogPostAPI = {
  getBlogPosts: async (params?: { author?: string; tag?: string; startDate?: string; endDate?: string }) => {
    const response = await apiClient.get('/blog-posts', { params });
    return response.data;
  },
  getBlogPost: async (id: string) => {
    const response = await apiClient.get(`/blog-posts/${id}`);
    return response.data;
  },
  createBlogPost: async (data: any) => {
    const response = await apiClient.post('/blog-posts', data);
    return response.data;
  },
  updateBlogPost: async (id: string, data: any) => {
    const response = await apiClient.put(`/blog-posts/${id}`, data);
    return response.data;
  },
  deleteBlogPost: async (id: string) => {
    const response = await apiClient.delete(`/blog-posts/${id}`);
    return response.data;
  },
};

export default apiClient; 